export const DOMAIN_DEMO_NAME = 'lp-gift-dev.senetpro.com';
export const DOMAIN_DEMO_NAME_API = 'api.dev.eboxenterprises.com';
export const DOMAIN_DEMO_API = 'https://'+DOMAIN_DEMO_NAME_API;
